import React from 'react';
import { Form, Table } from 'react-bootstrap';
import { gainssTestCaseFields } from '../../../static-data/DropdownOptions';

const fieldsRemovedFromMapping = ['Key', 'id', 'SNo', 'Automated On', 'Step No.'];
const UploadColumnMapping = ({
  csvData,
  columnMapping,
  handleMappingChange,
  hasAutomationFields = true,
}) => {
  const selectedFields = new Set(Object.values(columnMapping));

  return (
    <Form>
      <Table bordered>
        <thead>
          <tr>
            <th>CSV Field</th>
            <th style={{ textAlign: 'center' }}>→</th>
            <th>Gainss Field</th>
          </tr>
        </thead>
        <tbody>
          {csvData.length > 0 &&
            Object.keys(csvData[0])
              .filter((csvField) => !fieldsRemovedFromMapping.includes(csvField))
              .map((csvField, index) => (
              <tr key={index}>
                <td>{csvField}</td>
                <td style={{ textAlign: 'center' }}>→</td>
                <td>
                  <Form.Select
                    name={csvField}
                    onChange={handleMappingChange}
                    value={columnMapping[csvField] || ''}>
                    <option value="">None</option>
                    {gainssTestCaseFields
                      .filter((field) => {
                        const isAutomation = [
                          'isAutomated',
                          'automatedBy',
                          'automationMethod',
                        ].includes(field.key);
                        return hasAutomationFields ? true : !isAutomation;
                      })
                      .map((field) => (
                        <option
                          key={field.key}
                          value={field.key}
                          disabled={
                            selectedFields.has(field.key) &&
                            columnMapping[csvField] !== field.key
                          }>
                          {field.label}
                        </option>
                      ))}
                  </Form.Select>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </Form>
  );
};

export default UploadColumnMapping;
